var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"id":"core-app-bar","absolute":"","app":"","color":"transparent","flat":"","height":"88"}},[_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }